<template>
  <div>
    <div class="BottomArea">
      <div class="split"></div>
      <div class="afterSale">
        <div class="tel1">
          <div class="imgBox">
            <img src="../../assets/images/productCenterIMG/3.png" alt="" />
          </div>
          <div class="telLeft">
            <div style="font-size: 18px;">售后电话</div>
            <div style="font-size: 22px;">0574-87639797</div>
          </div>
        </div>
        <div class="tel1">
          <div class="imgBox">
            <img src="../../assets/images/productCenterIMG/4.png" alt="" />
          </div>
          <div class="telLeft">
            <div style="font-size: 18px;">服务热线</div>
            <div style="font-size: 22px;">400-6688-076</div>
          </div>
        </div>
        <div class="tel1">
          <div class="imgBox">
            <img src="../../assets/images/productCenterIMG/5.png" alt="" />
          </div>
          <div class="telLeft">
            <div style="font-size: 18px;">公司传真</div>
            <div style="font-size: 22px;">0574-87630469</div>
          </div>
        </div>
        <div class="tel1">
          <div class="imgBox">
            <img src="../../assets/images/productCenterIMG/7.png" alt="" />
          </div>
          <div class="telLeft">
            <div style="font-size: 18px;">售后服务时间</div>
            <div style="font-size: 22px;">08:00-17:00</div>
          </div>
        </div>
      </div>
      <div class="address">
        <div>
          <img src="../../assets/images/productCenterIMG/6.png" alt="" />
          <span>浙江省宁波市江北区通惠路788号</span>
        </div>
      </div>
    </div>
    <div class="copyright">
      <div style="font-size: 12px; text-algin: center;">
        版权所有©<i style="margin: 0 5px;"></i>宝成企业<i
          style="margin: 0 10px;"
        ></i>
        <a
          href="https://beian.miit.gov.cn/?spm=5176.28508143.J_9220772140.60.e939154azVp6y8#/Integrated/index"
          target="_blank"
        >
        浙ICP备18011530号-2</a> <i style="margin: 0 10px;"></i> <a
          href="https://beian.mps.gov.cn/#/query/webSearch"
          target="_blank"
        >浙公网安备 33020502000426号</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {};
  },
  components: {},
};
</script>

<style scoped lang="less">
.BottomArea {
  box-sizing: border-box;
  margin: 50px 0 0 0;
  height: 500px;
  width: 100%;
  background-color: #f0f1f3;
  .split {
    width: 100%;
    height: 40px;
    background-color: #1ebab9;
  }
  .afterSale {
    width: 100%;
    box-sizing: border-box;
    height: 150px;
    margin-top: 100px;
    margin-bottom: 50px;
    padding: 0 200px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .tel1 {
      display: flex;
      justify-items: center;
      .telLeft {
        display: flex;
        flex-direction: column;
        justify-content: center;
        div {
          margin: 5px 20px;
        }
      }
    }
  }
  .address {
    width: 100%;
    height: 100px;
    display: inline-block;
    div {
      text-align: center;
      width: 500px;
      height: 100px;
      margin: 0 auto;
      img {
        vertical-align: bottom;
        margin-right: 30px;
      }
      span {
        font-size: 18px;
        letter-spacing: 5px;
      }
    }
  }
}
.copyright {
  width: 100%;
  height: 100px;
  div {
    width: 488px;
    height: 100px;
    line-height: 100px;
    margin: 0 auto;
  }
}
</style>
